import { ElementType, FunctionComponent, SyntheticEvent } from 'react';
import classNames from 'classnames';
import { ContainerQuery } from 'react-container-query';

import { BREAK_POINTS } from '../../providers/ResponsivityProvider/ResponsivityProvider';
import VolumeComponentProps from '../../utils/props';
import { mapToCssModules } from '../../utils/map-to-css-modules/map-to-css-modules';

export interface CardProps extends VolumeComponentProps {
  /**
   * ReactDom tag to use for the Card
   * @default 'div'
   */
  tag?: ElementType;

  /**
   * Adds the 'text-white' modifier class if inverse is true
   */
  inverse?: boolean;

  /**
   * Appends the ${color}  modified to either border or bg class based on the value of the outline boolean flag
   */
  color?: string;

  /**
   * Adds the 'border-${color}' modifier class if outline is true
   * Adds the 'bg-${color}' modifier class if outline is false
   * @default false
   */
  outline?: boolean;

  /**
   * Adds the 'vol-card__body' modifier class if body is true
   */
  body?: boolean;

  /**
   * Adds the onClick event handler, to handle events.
   */
  onClick?: (e: SyntheticEvent) => void;
}

export const Card: FunctionComponent<CardProps> = ({
  body,
  children,
  className,
  color,
  cssModule,
  inverse,
  outline = false,
  tag = 'div',
  onClick,
  ...attributes
}: CardProps) => {
  const onClickHandler = (e: SyntheticEvent) => {
    onClick?.(e);
  };

  let Tag = tag;

  if (onClick && Tag !== 'button') {
    Tag = 'button';
  }

  return (
    <ContainerQuery query={{ 'vol-card--small': { minWidth: BREAK_POINTS.small } }}>
      {(params) => {
        const classes = mapToCssModules(
          classNames(className, params, 'vol-card', {
            'text-white': inverse,
            [`border-${color}`]: outline && color,
            [`bg-${color}`]: !outline && color,
            'vol-card__body': body,
          }),
          cssModule,
        );

        return (
          <Tag {...attributes} className={classes} onClick={onClickHandler}>
            {children}
          </Tag>
        );
      }}
    </ContainerQuery>
  );
};

export default Card;
